// @ts-nocheck
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import {
    AvailabilityMessageType,
    ProductDto,
    WishListLineModel,
    WishListModel,
} from "@insite/client-framework/Types/ApiModels";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
import Checkbox, { CheckboxPresentationProps, CheckboxProps } from "@insite/mobius/Checkbox";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import OverflowMenu, { OverflowMenuPresentationProps } from "@insite/mobius/OverflowMenu";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

/* Valtech Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import ProductDescription, { ProductDescriptionStyles } from "@store/Overrides/Components/ProductDescription";
import ProductImage, { ProductImageStyles } from "@store/Overrides/Components/ProductImage";
import { productLineProps } from "@store/Themes/common/props/productLine";
/* Valtech Custom Code - End */

interface OwnProps {
    wishList: WishListModel;
    wishListLine: WishListLineModel;
    productContext: ProductContextModel;
    isSelected: boolean;
    selectChangeHandler: CheckboxProps["onChange"];
    onViewReplacementProduct?: (wishListLine: WishListLineModel) => void;
    onDeleteClick: (wishListLine: WishListLineModel) => void;
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const replacementProductInfo =
        state.pages.myListDetails.replacementProductInfosByWishListLineId[ownProps.wishListLine.id];

    return {
        replacementProductInfo,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface MyListsDetailsDiscontinuedProductListLineStyles {
    selectedCheckbox?: CheckboxPresentationProps;
    restrictedDescriptionText?: TypographyPresentationProps;
    productPartNumbersStyles?: ProductPartNumbersStyles;
    deleteLink?: LinkPresentationProps;
    discontinuedChipGridItem?: GridItemProps;
    disconitnuedDeleteOverflow?: GridItemProps;
    discontinuedGridContainer?: GridContainerProps;
    disconitnuedDelete?: GridItemProps;
    discontinuedDescriptionGridItem?: GridItemProps;
    discontinuedTagGridContainer?: GridContainerProps;
    replacementItemGridItem?: GridItemProps;
    viewReplacementLink?: LinkPresentationProps;
    discontinuedSelectedCheckboxHidden?: HiddenProps;
    innerGridContainer?: GridContainerProps;
    viewReplacementGridItem?: GridItemProps;
    chipGridItem?: GridItemProps;
    discontinuedLineContainer?: GridContainerProps;
    discontinuedProductInfoGridItem?: GridItemProps;
    discontinuedPartNumbersGridItem?: GridItemProps;
    chipTypographyStyles?: TypographyPresentationProps;
    disconitnuedDeleteOverflowMenu?: OverflowMenuPresentationProps;
    discontinuedOverflowDeleteClickable?: ClickablePresentationProps;
    // Valtech Custom Code
    restrictedMessageGridItem?: GridItemProps;
    restrictedMessage?: InfosBoxProps;
    imageGridItem?: GridItemProps;
    productImageStyles?: ProductImageStyles;
    productInfoGridItem?: GridItemProps;
    productInfoContainer?: GridContainerProps;
    productBrandStyles?: ProductBrandStyles;
    productDescriptionStyles?: ProductDescriptionStyles;
    notesWrapper?: InjectableCss;
    notesStyles?: SmallHeadingAndTextStyles;
}

export const discontinuedProductListLineStyles: MyListsDetailsDiscontinuedProductListLineStyles = {
    discontinuedLineContainer: productLineProps.contentContainer,
    restrictedMessageGridItem: productLineProps.messageGridItem,
    restrictedMessage: productLineProps.messageInfosBox,
    imageGridItem: productLineProps.imageGridItem,
    productImageStyles: productLineProps.image,
    deleteLink: productLineProps.removeLink,
    discontinuedProductInfoGridItem: productLineProps.contentGridItem,
    innerGridContainer: productLineProps.contentContainer,
    productInfoGridItem: productLineProps.infoGridItem,
    productInfoContainer: productLineProps.contentContainer,
    discontinuedDescriptionGridItem: productLineProps.descriptionGridItem,
    productBrandStyles: productLineProps.brand,
    productDescriptionStyles: productLineProps.description,
    discontinuedPartNumbersGridItem: productLineProps.partNumbersGridItem,
    productPartNumbersStyles: productLineProps.partNumbers,
    notesWrapper: productLineProps.notesWrapper,
    viewReplacementLink: productLineProps.viewReplacementLink,
};

const Chip = styled.div`
    text-align: center;
    padding: 5px;
    background-color: #fcefc7;
    color: #000;
    border-radius: 5px;
`;

const styles = discontinuedProductListLineStyles;

const MyListDetailsDiscontinuedProductListLine: React.FC<Props> = ({
    isSelected,
    selectChangeHandler,
    productContext,
    onViewReplacementProduct,
    onDeleteClick,
    wishList,
    wishListLine,
    replacementProductInfo,
}) => {
    const product = productContext.product;
    const canEditWishList = (wishList.allowEdit || !wishList.isSharedList) && !wishList.isAutogenerated;
    const showViewReplacementProduct =
        canEditWishList &&
        wishListLine.replacementProduct?.canAddToWishlist &&
        !isReplacementProductDiscontinued(wishListLine.replacementProduct, replacementProductInfo);

    return (
        <GridContainer
            {...styles.discontinuedLineContainer}
            className="wishlist-discontinued-line-grid-container"
            data-test-selector={`${wishListLine.productId}_${wishListLine.selectedUnitOfMeasure}`}
        >
            {/* Valtech Custom Code - Start */}
            <GridItem {...styles.restrictedMessageGridItem}>
                <InfosBox {...styles.restrictedMessage}>
                    {siteMessage("Lists_Item_Not_Displayed_Due_To_Discontinued")}
                </InfosBox>
            </GridItem>
            <GridItem {...styles.imageGridItem}>
                <ProductImage product={product} extendedStyles={styles.productImageStyles} />
                {canEditWishList && (
                    <Link
                        {...styles.deleteLink}
                        onClick={() => onDeleteClick(wishListLine)}
                        data-test-selector="deleteListItem"
                        className="wishlist-discontinued-line-delete-link"
                    >
                        {translate("Remove")}
                    </Link>
                )}
            </GridItem>
            {/* Valtech Custom Code - End */}
            <GridItem {...styles.discontinuedProductInfoGridItem}>
                {/* Valtech Removed - selectedCheckbox */}
                <GridContainer {...styles.innerGridContainer}>
                    <GridItem {...styles.productInfoGridItem} /* Valtech Custom Code */>
                        <GridContainer {...styles.productInfoContainer} /* Valtech Custom Code */>
                            <GridItem
                                {...styles.discontinuedDescriptionGridItem}
                                className="wishlist-discontinued-line-description-grid-item"
                            >
                                {/* Valtech Custom Code - Start */}
                                {product.brand && (
                                    <ProductBrand brand={product.brand} extendedStyles={styles.productBrandStyles} />
                                )}
                                <ProductDescription
                                    product={product}
                                    extendedStyles={styles.productDescriptionStyles}
                                    className="wishlist-discontinued-line-description-text"
                                />
                                {/* Valtech Custom Code - End */}
                            </GridItem>
                            <GridItem
                                {...styles.discontinuedPartNumbersGridItem}
                                className="wishlist-discontinued-line-product-part-number-grid-item"
                            >
                                <ProductPartNumbers
                                    productNumber={product.productNumber}
                                    customerProductNumber={product.customerProductNumber}
                                    manufacturerItem={product.manufacturerItem}
                                    extendedStyles={styles.productPartNumbersStyles}
                                />
                            </GridItem>
                            {/* Valtech Removed - chipGridItem */}
                        </GridContainer>
                    </GridItem>
                </GridContainer>
                {/* Valtech Removed - viewReplacementGridItem */}
                {/* Valtech Custom Code - Start */}
                {wishListLine.notes ? (
                    <StyledWrapper {...styles.notesWrapper}>
                        <SmallHeadingAndText
                            heading={translate("Notes")}
                            text={wishListLine.notes}
                            extendedStyles={styles.notesStyles}
                        />
                    </StyledWrapper>
                ) : null}
                {/* Valtech Custom Code - End */}
                {showViewReplacementProduct && (
                    <Link
                        className="wishlist-discontinued-line-view-replacement-link"
                        {...styles.viewReplacementLink}
                        onClick={() => onViewReplacementProduct?.(wishListLine)}
                        data-test-selector="replacementProductLink"
                    >
                        {translate("View Replacement Product")}
                    </Link>
                )}
            </GridItem>
            {/* Valtech Moved - canEditWishList - up */}
            {/* Valtech Removed - disconitnuedDeleteOverflow */}
        </GridContainer>
    );
};

function isReplacementProductDiscontinued(replacementProduct: ProductDto, productInfo: ProductInfo | undefined) {
    if (!replacementProduct || !productInfo) {
        return true;
    }
    const availability = productInfo.inventory?.inventoryAvailabilityDtos?.find(
        o => o.unitOfMeasure.toLowerCase() === productInfo.unitOfMeasure.toLowerCase(),
    )?.availability;

    return replacementProduct.isDiscontinued && availability?.messageType === AvailabilityMessageType.OutOfStock;
}

export default connect(mapStateToProps)(MyListDetailsDiscontinuedProductListLine);
